import { apiService } from "./index";

const userNoteService = {
  getForProgramSite(programSiteId) {
    return apiService.get(
      `/program_site_user_notes/for/${programSiteId}`
    );
  },

  create(data) {
    return apiService.post("/program_site_user_notes", data);
  },

  update(id, data) {
    return apiService.put(`/program_site_user_notes/${id}`, data);
  },

  destroy(id) {
    return apiService.delete(`/program_site_user_notes/${id}`);
  },

  flagForRemoval(id) {
    return apiService.post(`/program_site_user_notes/${id}/flag_for_removal`);
  },
};

export { userNoteService };
